/** Hyperliquid rejects exchange actions until the wallet has received a first USDC deposit. */
export function isHlDepositRequiredError(message) {
  const s = String(message || '').toLowerCase();
  return s.includes('must deposit before performing actions') || s.includes('must deposit');
}

export function formatHlDepositError(message, walletAddress) {
  if (!isHlDepositRequiredError(message)) return message;
  const w = walletAddress
    ? `${walletAddress.slice(0, 6)}…${walletAddress.slice(-4)}`
    : 'your linked wallet';
  return (
    `Hyperliquid requires a first USDC deposit on ${w} before wallet approvals or live trading. ` +
    'Use Fund Hyperliquid below — deposit USDC on Arbitrum from your EVM wallet, or send SOL from Phantom (see SOL tab); HL usually credits in about a minute.'
  );
}

export function parseApiError(err, walletAddress) {
  const raw = err?.response?.data?.error || err?.message || String(err);
  return formatHlDepositError(raw, walletAddress) || raw;
}
